<script setup>
import { defineProps, defineEmits, inject } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

const store = useStore()
const router = useRouter()
const storeFourBaseUrl = inject('storeFourBaseUrl')
const emit = defineEmits(['backToPrevStep'])
const props = defineProps({
  items: {
    type: Array,
    required: true
  },
  lastOptionSelected: {
    type: Number,
    required: true
  }
})
const closeMenu = () => {
  store.dispatch('megaMenu/closeMenu')
}
const getIconSrc = (image) => {
  return `${storeFourBaseUrl}/filepond/menu/${image}`
}
const backToPrevStep = (level) => {
  emit('backToPrevStep', level)
}
const gotoFilteredCourses = (params) => {
  //If link is external redirect to it
  if (params.startsWith('http')) {
    window.location = params
  } else { // else go to filtered courses with vue router
    router.push(params)
  }
  store.dispatch('megaMenu/closeMenu')
}
</script>
<template>
  <div>
    <v-list-item v-if="$vuetify.display.mdAndDown" @click="closeMenu" width="100%" class="d-flex justify-center">
      <v-icon size="large" icon="$mdiMinus"></v-icon>
    </v-list-item>
    <v-list-item v-if="$vuetify.display.mdAndDown" @click="backToPrevStep(2)">
      <v-icon icon="$mdiArrowRight"  class="ml-2"></v-icon>
      <span v-if="props.lastOptionSelected[1]">{{ props.lastOptionSelected[1] }}</span>
      <span v-else>{{ props.lastOptionSelected[0] }}</span>
    </v-list-item>
    <v-list-subheader class="font-weight-medium mx-3 mb-2" :class="[!$vuetify.display.mdAndDown? 'border-b-sm':'']">
      <span v-if="!$vuetify.display.mdAndDown" class="text-black font-weight-bold">دسته‌بندی‌ها</span>
      <span v-else>انتخاب دوره</span>
    </v-list-subheader>

    <v-list-item
      color="primary"
      :class="[$vuetify.display.mdAndDown?'border-b-sm':'', i>=props.items.length-1?'mb-12':'']"
      v-for="(item, i) in props.items"
      :key="i"
      class="my-3"
      @click="gotoFilteredCourses(item.link)"
    >
      <template v-slot:prepend>
        <v-img :src="getIconSrc(item.icon_img)" width="70" class="ml-4 rounded-lg" />
      </template>
      <template v-slot:append v-if="!$vuetify.display.mdAndDown">
        <v-chip size="small" class="rounded-lg">{{ item.category_product_count }}</v-chip>
        <v-icon icon="$chevronLeft"></v-icon>
      </template>
      <v-list-item-title class="font-weight-medium mb-3">
        <span class="font-weight-bolder" :class="$vuetify.display.mdAndDown?'mb-2':''">{{ item.title }}</span>
        <template v-if="!$vuetify.display.mdAndDown">
          <v-chip
            size="small"
            class="rounded-lg ms-2 font-weight-bold"
            :class="[chips.type ==='success' ? 'mega-menu__success__chip' : 'mega-menu__primary__chip']"
            :color="chips.type"
            v-for="(chips, i) in item.tags"
            :key="i">
            {{ chips.name }}
          </v-chip>
        </template>
      </v-list-item-title>
      <v-list-item-title class="d-flex flex-wrap" v-if="$vuetify.display.mdAndDown">
        <v-chip
          size="medium"
          :class="[chips.type ==='success' ? 'mega-menu__success__chip' : 'mega-menu__primary__chip']"
          class="rounded-lg font-weight-bold m-2 px-1"
          :color="chips.type"
          v-for="(chips, i) in item.tags"
          :key="i">
          {{ chips.name }}
        </v-chip>
      </v-list-item-title>
      <v-list-item-subtitle v-if="!$vuetify.display.mdAndDown">
        {{ item.description }}
      </v-list-item-subtitle>
    </v-list-item>
    <v-list-item v-if="$vuetify.display.mdAndDown" width="100%" class="position-fixed bottom-0">
      <v-btn height="45px" @click="closeMenu()" :to="{name:'courses'}" width="100%" variant="outlined" style="letter-spacing: 0"> مشاهده همه دوره‌ها</v-btn>
    </v-list-item>
    <div v-else class="menu-fixed-section d-flex justify-center align-items-center py-3">
      <v-btn @click="closeMenu()" :to="{name:'courses'}" class="text-decoration-none" width="90%" variant="flat" border style="letter-spacing: 0">
        نمایش همه دوره‌ها
      </v-btn>
    </div>
  </div>
</template>

<style scoped>
.mega-menu__primary__chip{
  border: 1px solid #B2CCFF;
}
.mega-menu__success__chip{
  border: 1px solid #A9EFC5;
}
</style>
